import { ContentService, ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes } from '../interfaces';
import * as Cropper from '../../../../../org/Hibachi/client/lib/cropperjs/cropper.min.js'

class ImageCropperModalController {
	
	//http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
	public id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

	
	public contentModule;
	
	public docImage;
	public image;
	public imageContainer;
	public imageContainerID:string;
	public imageDetail;
	public imageUploadModalController;
	
	public tempImage;
	
	public cropper;
	
	public cropping = false; 
	public saving = false;
	
	// @ngInject
	constructor(
		public $compile,
		public $scope, 
		public $timeout,
		public imageService		: ImageService,
		public contentService	: ContentService, 
		public observerService	: ObserverService,
		public ModalService: { openModals: any[]; }
	){}
	
	public $onInit = () => {
		
		this.imageContainerID = 'imageContainer' + this.id;
		
		this.imageContainer = document.getElementById('toCompile');

		//because we're using this as a modal within a modal we need to manually compile
		this.$compile(this.imageContainer)(this.$scope);

		this.docImage = document.createElement('img');
		
		this.docImage.id = 'imageToCrop';
		
		if(this.image.image_s3PathToImageFile != null){
			this.docImage.src = this.image.image_s3PathToImageFile;
			this.docImage.alt = this.image.image_imageName;
		} else {
			this.docImage.src = this.image.s3PathToImageFile;
			this.docImage.alt = this.image.imageName;
		}

        this.docImage.crossorigin = true;
        
        this.imageContainer.appendChild(this.docImage);
        
        //temporarily hardcoded so that it will fit in the modal
        this.docImage.style.width = 500 + "px";
		
		this.cropper = new Cropper(this.docImage, {
			  autoCrop: false,
			  background: false,
			  dragMode: 'move',
			  //preview: '.preview',
			  viewMode: 2,
			  ready: () => {
				//init logic lives here;
			  },
			  crop: (event)=> {
			  	
				this.imageDetail = event.detail;
			  	
			  },
		});
	}	
	
	public $onDestroy = () =>{
		this.cropper.destroy();
	}
	
	public getCroppedImage = () =>{
		if( this.cropper.getCroppedCanvas() == null){
			return this.docImage.src;
		} 
		return this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
	}
	
	public crop = () =>{
		
		if(!this.cropping){
			
			this.cropping = true;
			this.cropper.setDragMode('crop');
		
			
		} else {
			
			this.cropping = false; 
			this.cropper.replace(this.getCroppedImage());
			this.docImage.src = this.getCroppedImage();
		}
	}
	
	public rotateRight = () =>{
		this.cropper.rotate(90);
	}
	
	public rotateLeft = () =>{
		this.cropper.rotate(-90);
	}
	
	public save = () => {
		this.saving = true;

		if(this.image.contentModuleImageID != null){
			return this.imageService.uploadImageToContentModuleImage(this.getCroppedImage(), this.image).then((response: any)=>{

				if(response.data.data.success){
					
					if(this.imageUploadModalController.imageUploadCreatedEntity){
						if(response.data.data.lesson){
							this.imageUploadModalController.setEventData = response.data.data.lesson;
						} else if (response.data.data.portfolioPage){
							this.imageUploadModalController.setEventData = response.data.data.portfolioPage;
						}
					}
					
					this.observerService.notify('contentModuleImageUpdated', response.data.data.contentModuleImage);
				}
				
				this.close();
			});
		} else if( this.contentModule != null && 
			this.contentModule.contentModuleID != null && 
			this.contentModule.contentModuleID.length === 3
		){
			//create content module and content module image and image
			//however with current flows this shouldn't be needed
			console.warn('create content module and content module image and image not implemented for image crop')
		} else {
			//create everything
			//however with current flows this shouldn't be needed
			console.warn('create everything not implemented for image crop')
		}
	this.saving = false;
	}
	
	public close = () =>{
		
		this.cropper.destroy();
		
		var modalToCloseIndex = 0;
		if(this.ModalService.openModals.length === 2){
			modalToCloseIndex = 1;
		}
		//This is a workaround ModalService technically does not support more than one modal
		this.ModalService.openModals[modalToCloseIndex].modal.element.modal('hide');
		this.ModalService.openModals.splice(modalToCloseIndex, 1);
	}
	
}

class ImageCropperModal {
	
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		contentModule: '=',
		image: '=',
		imageUploadModalController: '='
	};

	public controller = ImageCropperModalController;
	public controllerAs = 'imageCropperModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-cropper-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCropperModal };
